import type {
  PostBoardsUserRolesRequestType,
  PostBoardsUserRolesResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const postBoardsUserRoles = async ({
  boardId,
  ...params
}: PostBoardsUserRolesRequestType) => {
  const url = `/api/v2/boards/${boardId}/user-roles`;
  const result = await apiAuthClient.post<PostBoardsUserRolesResponseType>(
    url,
    params,
  );

  return result.data;
};
